/**
 * Gate for org-scoped pages: a meta-admin must have picked an active org before
 * the org area renders (the backend 403s org-scoped reads without an `orgId`).
 * Org-admins always have an implicit scope, so they pass straight through.
 *
 * When a meta-admin has no scope, we send them to the orgs picker rather than
 * firing doomed API calls.
 */
import type { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useOrgScope } from './OrgScopeContext.js';

export function RequireOrgScope({ children }: { children: ReactNode }): ReactElement {
  const { isMeta, orgId } = useOrgScope();
  if (isMeta && !orgId) {
    return <Navigate to="/meta/orgs" replace />;
  }
  return <>{children}</>;
}
